var _style, _path, _path2, _path3, _polyline, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _polygon, _g, _path12, _path13, _path14, _path15, _path16, _g2, _g3, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortunioHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000052786813888182811860000015071311904956706231_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 774 731.4",
    style: {
      enableBackground: "new 0 0 774 731.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FEEF66;}\n\t.st1{fill:#CB3E17;}\n\t.st2{fill:#4F1C24;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:#DF4D13;}\n\t.st5{fill:#F18530;}\n\t.st6{fill:url(#SVGID_00000173148452699727322840000009740409181502457521_);}\n\t.st7{fill:none;stroke:#BE3318;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:url(#SVGID_00000129182660144816534020000011229281851403935125_);}\n\t.st9{fill:none;stroke:#C85617;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:#C85617;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:none;stroke:#39211B;stroke-width:0.6;stroke-linecap:round;stroke-linejoin:round;}\n\t.st13{fill:#39211B;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.6,173.3c0,0,2.2-29.1,8-33.5s11.1-17.6,10.5-29.8s4.8-15.2,9.3,2.9c9.2-6.4,12.6-8.9,12.6-8.9 s6.7-19.6,8.6-25.4s3.2-27.3,6.1-28.3s4.5,16.6,4.5,21.9c0,5.4-6.1,27.9-6.1,27.9s16.9-21.1,17.4-25.5s4.7-32.2,7.1-34.7 c2.4-2.5,5.5,21,5.6,27.8c0.1,6.8-8.1,28.4-8.1,28.4S358,78.7,360,74.8c1.9-3.9,11.3-56.7,14.7-61.6s8.2-9.8,7.8-0.1 c-0.4,9.8-8.4,60.1-10.8,67.9c-2.4,7.8-31.5,30-31.5,30s15.1-6.4,17-7.9s1.5,5.8-4.8,10.3c-6.3,4.4-11.6,9.3-18,10.4 c-6.3,1-36.5,9-45.8,16.4s-14.9,33.1-14.9,33.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M482.9,565.2c-2.5,0,23.1,56.8,38.7,70.8c-19.8,32.9-42.8,88.1-42.8,88.1h28.8c4.1-28.8,32.9-93.1,32.9-93.1 s-2.5-45.3,14.8-65.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M507.6,724.2c0.6-4.2,1.7-9.2,3.2-14.6l-23.6-4.9c-5.2,11.6-8.5,19.5-8.5,19.5H507.6L507.6,724.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.43,
    y1: 98.425,
    x2: 381.77,
    y2: 98.425,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEF26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEEE26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#F8C429"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#F3A22C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#EF882F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#EC7530"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#EA6931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EA6632"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FDC800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#F18F34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#E95F32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB2F"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "323.4,553.7 365.4,707.7 363.5,724.2 381.8,724.2 349.8,543  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.8,543l-26.4,10.7l17.7,65c7.6,7.2,16.9,15.5,25.9,22.4L349.8,543L349.8,543z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263,177.4c2.1,1-6.8-10.1-18.4-19s-33-7.4-58.6-12.1c-25.6-4.6-43.7-29.8-48.3-44.2 c-4.7-14.4,13.5,14.9,33.5,20.4c-20-22.3-27-45.6-28.8-53.4s7-25.6,8.8-28.4s1.4,20,1.9,29.8c0.5,9.8,13.5,22.8,13.5,22.8 s-2.8-44.6,0-57.2c2.8-12.6,9.7-32.5,14.1-35.8s1.6,16.3,0,34.9c-1.6,18.6,2.2,49.8,3.1,53.5c0.9,3.7,10.7,16.2,10.7,16.2 s1.4-31.2,3.2-42.8s5.1,0.5,7.9,11.6c2.8,11.2,3.7,42.8,7.4,46s17.2,11.2,17.2,11.2s-4.7-14.4-1.4-17.2 c3.2-2.8,10.7,23.7,14.9,28.8c4.2,5.1,14.6,12.6,17.8,14.9c3.2,2.3,6.4,17.7,6.4,17.7L263,177.4L263,177.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M594.4,498c0,0,4.4-21.5,19.1-21.5s26.8,19.7,28.2,27.4s-5.9,7.9-12.9,0.9c12.4,19.1,10.3,34.5-4.1,19.1 c3.2,18-10.9,26.8-24.1,5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.8,505.5c-3.4-9.8-14.4-16.2-20.8-19.3c-3.4,5.7-4.6,11.8-4.6,11.8l6.2,30.9c6.5,10.8,13.3,14,18.1,12.4 C620.6,531.1,623,514.7,619.8,505.5L619.8,505.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.9,177.4c0,0,15.7-37.1,44.5-37.9C328.9,164.2,310.8,172.5,286.9,177.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M297.1,171.1c0,0,12.4-24.8,31.9-27.5c-1.8,17-16.4,26.6-25.6,29.4C297.3,174.9,297.1,171.1,297.1,171.1 L297.1,171.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136408645873827664700000013183790684727170743_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.9076,
    y1: 0.53,
    x2: 459.9076,
    y2: 561.87,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEF26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEEE26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#F8C429"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#F3A22C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#EF882F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#EC7530"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#EA6931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EA6632"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FDC800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#F18F34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#E95F32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB2F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136408645873827664700000013183790684727170743_)"
    },
    d: "M272.3,170.1c0,0,111.8,4.7,127.5,7.1 c39.4-3.9,49.6,0,49.6,0s0.8,66.1-19.7,81.1s-53.5-3.1-63-27.6c-9.4-24.4,4.6-40.4,16.5-47.2c11.9-6.8,11.8,44.1,11.8,44.1 l-11.8,9.4l-68.5-2.4c0,0-5.5-18.9,17.3-22.8s32.3,70.1,40.1,95.3c7.9,25.2,44.1,132.3,44.1,132.3s135.4,38.6,161.4,46.5 c26,7.9,39.4,16.5,30.7,44.1c-8.7,27.5-7.9,64.5,13.4,91.3C640,648.8,666,731.5,666,731.5h-32.3l6.3-22l-33.1-79.5 c0,0-44.9-26.8-68.5-63.8s-18.9-59,5.5-54.3c24.4,4.7,37.8,31.5,37.8,31.5l-5.5,32.3c0,0-126,26.8-180.3,18.9 c-54.3-7.9-59-27.5-59-27.5s14.2,37-18.1-6.3C303.8,541,303,537,303,537s3.9,42.5-22-9.5s-28.3-315.7-26.8-336.9 S272.3,170.2,272.3,170.1L272.3,170.1z"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M633.7,731.4H666c0,0-2-6.5-5.4-16.5l-21.5-2.3L633.7,731.4L633.7,731.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M606.9,629.9c0,0-44.9-26.8-68.5-63.8c-15.3-24-18.7-41.7-12.5-49.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M399.9,177.2c39.4-3.9,49.6,0,49.6,0s0.8,66.1-19.7,81.1s-53.5-3.1-63-27.6c-9.4-24.4,4.6-40.4,16.5-47.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263,182.3c0,0-28-33.8-82.4-19.8c21.4,34.6,58.5,37.9,82.4,28.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023996029846741061820000003738835469650893966_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.77,
    y1: 98.425,
    x2: 440.11,
    y2: 98.425,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#FDC800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#E95F32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDB2F"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000023996029846741061820000003738835469650893966_)"
    },
    points: "381.8,553.7 423.8,707.7  421.8,724.2 440.1,724.2 408.1,543  "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "423.8,707.7 421.8,724.2 440.1,724.2 436.4,703.3 422.7,703.8  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 418.5,
    y1: 601.5,
    x2: 408.1,
    y2: 543
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 381.8,
    y1: 553.7,
    x2: 395.1,
    y2: 602.5
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M434.8,235.6c0,0-8.3,4.9-17.4,4.8c-12.5-0.2-24.7-12.7-24.7-12.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M412.8,211.7c0,0-2.5-11.4-14-13C387.4,197.2,393.5,209.4,412.8,211.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M428.1,211.7c0,0,5.9-14.8,15-10.9C452.3,204.6,437.2,210.5,428.1,211.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.8,242.1c-1.2-3.6-2-5.8-2-5.8l0,0h-41.2c0,0,38.8,35.9,54.5,50.3C364,272.7,360.4,256.1,355.8,242.1 L355.8,242.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256.8,183.7c0,0-32.7-24.1-61.1-17c5.5,17.6,32.3,24.1,59.7,22.8C257.4,185.3,256.8,183.7,256.8,183.7 L256.8,183.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M306.9,189.6c0,0,1.3,6.1-5.5,8.2s-8.3-10.2-8.3-10.2S302.7,187.7,306.9,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M309.1,189.6c0,0-13.2-3.1-24.5-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M304,188.7c0,0,0.3,7.1-5,7c-5.3-0.1-5.9-8.1-5.9-8.1S301.1,187.7,304,188.7L304,188.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M307,174.6c0,0-2.3-8.7-5.7-9.9c-3.3-1.3-18.2,5.3-20.1,5.8c-1.9,0.6-1.5,6.2-1.5,6.2L307,174.6L307,174.6z "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M335.1,187.3c0,0,1.9,5.9-4.8,8.6c-6.6,2.8-9.2-9.4-9.2-9.4S330.7,185.7,335.1,187.3L335.1,187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M339.3,187.1c0,0-13.4-1.8-24.5,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M332.1,186.6c0,0,0.9,7-4.3,7.4c-5.3,0.4-6.7-7.5-6.7-7.5S329.2,185.9,332.1,186.6L332.1,186.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M310.2,175.2c0,0,2.4-8.7,5.7-9.9c3.3-1.3,18.2,5.3,20.1,5.8c1.9,0.6,1.5,6.2,1.5,6.2L310.2,175.2 L310.2,175.2z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M365.4,707.7l-2,16.5h18.3l-3.3-18.5c-4.3,0.3-9.5,0.8-13.2,1.4L365.4,707.7L365.4,707.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortunioHappy);
export default __webpack_public_path__ + "static/media/fortunio-happy.4aa79b62e8d9ee8dea5123ec86c0c3c3.svg";
export { ForwardRef as ReactComponent };